export default "__VITE_ASSET__r_TZTK9V__"